import React, { useState } from "react";
import useLanguageDirection from "../../hooks/useLanguageDirection";

export default function CustomInput({
  id,
  type = "text",
  placeholder,
  value,
  onChange,
  icon,
  isPassword = false,
  className = "",
  required
}) {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const direction = useLanguageDirection();

  return (
    <div className="relative w-full">
      {icon && (
        <span className="absolute inset-y-0 left-0 flex items-center text-gray-900">
          {icon}
        </span>
      )}

      <input
        id={id}
        dir={direction}
        type={isPassword && !isPasswordVisible ? "password" : type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`w-full px-2 md:px-5 py-2 md:py-3 text-black text-base sm:text-lg border border-gray-300 rounded-lg bg-white 
         placeholder:text-sm sm:placeholder:text-base ${className}`}
        required={required}
      />

      {isPassword && (
        <span
          className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-900 cursor-pointer"
          onClick={() => setPasswordVisible(!isPasswordVisible)}
        >
          {isPasswordVisible ? "👁️" : "👁️‍🗨️"}
        </span>
      )}
    </div>
  );
}
